import moment from 'moment'

import type { DaysTree } from 'modules/timeoff/lib/getDateRangeFromTree'
import type CompanyHoliday from 'modules/timeoff/store/models/CompanyHoliday'

import insertToTree from './insertToTree'

class CompanyHolidaysToDateTree {
  companyHolidays: CompanyHoliday[]
  memo: DaysTree

  constructor(companyHolidays: CompanyHoliday[]) {
    this.companyHolidays = companyHolidays
    this.memo = {}
  }

  munch() {
    this.companyHolidays.forEach((holiday: CompanyHoliday) => {
      const date = moment(holiday.attributes.date)
      const type = 'wrong'
      insertToTree(this.memo, type)(date)
    })

    return this.memo
  }
}

export default CompanyHolidaysToDateTree
